module.exports = __webpack_public_path__ + "static/media/download watchOS.0f3514a4.svg";